<template>
  <a-card
    :title="title"
    :extra="localizedDate"
    :bordered="false"
    :class="{card: true, today: isToday}"
    >

    <draggable
      v-model="tasks"
      group="tasks"
      filter=".undragabble"
      @start="drag=true"
      @end="drag=false"
    >
    <p v-for="(task, i) in dayObject.tasks" :key="task.id">
      <a-icon v-if="!userPreferences['layout.hideDragHandle']" type="ellipsis" class="drag-handle"></a-icon>
      <a-checkbox
        :checked="task.done"
        @change="onTaskCheckboxChange($event, task)"
      />
      <span
        :class="{taskSpan: true, done: task.done}"
        contentEditable="true"
        v-text="task.text"
        :ref="'taskSpans'"
        @keypress="onTaskSpanKeyPress"
        @keydown="onTaskSpanKeyDown($event, task, i)"
        @keyup="onTaskSpanKeyUp($event, task, i)"
        @blur="onTaskSpanBlur($event, task)"
      />
    </p>
    <p slot="footer" @click="onPlusClick" class="addTask undragabble">
      <a-icon type="plus" /> Add task
    </p>
    </draggable>

  </a-card>

</template>


<script>
import { mapGetters } from 'vuex';
import draggable from 'vuedraggable';
import { setEndOfContenteditable, shortId } from '@/utils';


export default {
  name: "DayCard",
  props: ["date", "dayObject"],
  components: {
    draggable,
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      userPreferences: 'prefs/getUserPreferences',
    }),
    isToday() {
      let today = this.$store.getters["weeks/getToday"]();
      return this.date.isSame(today, "day");
    },
    localizedDate() {
      return this.date.format('ll')
    },
    title() {
      return this.date.format('dddd');
    },
    tasks: {
      get() {
        return this.dayObject.tasks;
      },
      set(value) {
        this.$store.commit(
          'weeks/editDayObject',
          {dayObject: this.dayObject, key: "tasks", value: value},
        );
        this.$emit("dayCardUpdated");
      }
    },
  },
  methods: {

    addNewTask(position) {
      const newId = shortId();
      const newTask = {id: newId, text: "", done: false};
      this.$store.commit(
        'weeks/addTask',
        {dayObject: this.dayObject, position, task: newTask}
      );
      this.$emit("dayCardUpdated");

      this.$nextTick(() => {
        this.$refs.taskSpans[this.dayObject.tasks.length - 1].focus()
        }
      );
    },
    removeTask(position) {
      this.$store.commit(
        'weeks/removeTask',
        {dayObject: this.dayObject, position}
      );
      this.focusTask(position - 1);
      this.$emit("dayCardUpdated");
    },

    focusTask(position) {
      if (position < 0 || position >= this.dayObject.tasks.length) return;
      const compare = (a, b) => a.offsetTop-b.offsetTop;
      const spanAtPosition = this.$refs.taskSpans.sort(compare)[position];
      spanAtPosition.focus();
      setEndOfContenteditable(spanAtPosition);
    },

    onPlusClick() {
      this.addNewTask(this.dayObject.tasks.length);
    },

    onTaskCheckboxChange(event, task) {
      this.$store.commit(
        'weeks/editTask',
        {task, key: "done", value: event.target.checked}
      );
      this.$emit("dayCardUpdated");
    },

    onTaskSpanBlur(event, task) {
      this.$store.commit(
        'weeks/editTask',
        {task, key: "text", value: event.target.textContent}
      );
      this.$emit("dayCardUpdated");
    },

    onTaskSpanKeyPress(event) {
      if (
        event.key == "Enter" &&
        event.altKey === false &&
        event.ctrlKey === false &&
        event.shiftKey === false
      ) {
        event.preventDefault();
      }
    },

    onTaskSpanKeyDown(event, task, position) {
      //console.log(event);
      switch(event.key){
        case "Backspace":
          if (!event.target.textContent) {
            this.removeTask(position);
            event.preventDefault();
          }
          break;
        case "ArrowUp":
          this.focusTask(position - 1);
          event.preventDefault();
          break;
        case "ArrowDown":
          this.focusTask(position + 1);
          event.preventDefault();
          break;
      }

    },

    onTaskSpanKeyUp(event, task, position) {
      if (
        event.key == "Enter" &&
        event.altKey === false &&
        event.ctrlKey === false &&
        event.shiftKey === false
      ) {
        this.addNewTask(position + 1);
      }
    },

  },

}
</script>


<style scoped>

[contenteditable]:focus {
    outline: 0px solid transparent;
}

p {
  text-align: left;
}

.done {
  text-decoration: line-through;
  color: #bbb;
}

.addTask {
  cursor: pointer;
}

.card {
  flex: 1;
  min-width: 250px;
  max-width: 350px;
  margin-right: 15px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.card.today {
  border-right: 2px solid #1890ff;
}

.drag-handle {
  float: right;
  cursor: move;
}

.taskSpan {
  white-space: pre-wrap;
}

</style>

